import { getCommonTimezones, TIMEZONE_LOCAL } from '#layers/base/utils/timezone';
import { BuiltinBlockIds } from '#layers/data-model/constants/builtin-block-ids';
import { PRIMITIVE_TYPE_DATE, PRIMITIVE_TYPE_DATE_TIME, PRIMITIVE_TYPE_DATE_TIME_WITH_TIMEZONE, PRIMITIVE_TYPE_INT32, PRIMITIVE_TYPE_INT64, PRIMITIVE_TYPE_TIME } from '#layers/data-model/constants/schema/primitive-type';
import { defineFieldTypeTemplate } from '../define';

export interface DatetimeFieldOptions {
	defaultTimezone?: string;
}

export default defineFieldTypeTemplate<DatetimeFieldOptions>({
	type: 'primitive',
	id: 'datetime',
	name: '$t:field_types.datetime.name',
	description: '$t:field_types.datetime.description',
	icon: 'lucide:calendar',
	sort: 200,
	keywords: ['date', 'time', 'timestamp', 'calendar'],
	supportedPrimitiveTypes: [
		PRIMITIVE_TYPE_DATE_TIME,
		PRIMITIVE_TYPE_DATE_TIME_WITH_TIMEZONE,
		PRIMITIVE_TYPE_DATE,
		PRIMITIVE_TYPE_TIME,
		PRIMITIVE_TYPE_INT32,
		PRIMITIVE_TYPE_INT64,
	],
	options: ({ form, context }) => {
		const isTimezoneType = context.primitiveType.name === PRIMITIVE_TYPE_DATE_TIME_WITH_TIMEZONE;

		if (!isTimezoneType) {
			return form([]);
		}

		const timezoneOptions = [
			{
				label: '$t:field_types.datetime.options.local',
				value: TIMEZONE_LOCAL,
			},
			...getCommonTimezones().map(({ id, label, offset }) => ({
				label: `${label} (${offset})`,
				value: id,
			})),
		];

		return form([
			{
				name: 'defaultTimezone',
				label: '$t:field_types.datetime.options.default_timezone.label',
				description: '$t:field_types.datetime.options.default_timezone.description',
				block: BuiltinBlockIds.InputSelect,
				props: {
					options: timezoneOptions,
					placeholder: '$t:field_types.datetime.options.local',
				},
			},
		]);
	},
});
